var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('info-dialog-template', {
    attrs: {
      "title": _vm.$t('safe.deal.challenge.processing.title')
    },
    on: {
      "click": _vm.handleClose
    },
    model: {
      value: _vm.isShownDialog,
      callback: function callback($$v) {
        _vm.isShownDialog = $$v;
      },
      expression: "isShownDialog"
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_vm.hasDispute ? [_c('p', [_vm._v(_vm._s(_vm.$t('safe.deal.dispute.with.description')))]), _c('p', [_c('i', [_vm._v(_vm._s(_vm.$t(_vm.displayDisputeReason)))])])] : [_c('p', [_vm._v(_vm._s(_vm.$t('safe.deal.dispute.without.description')))])], _c('p', [_vm._v(_vm._s(_vm.$t('safe.deal.dispute.information')))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayAmountReturn)
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayPayoutNotAvailable)
    }
  })], 2), _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    class: _vm.$style.action
  }, [_vm.isProtestButton ? _c('link-button', {
    attrs: {
      "href": "https://help.capusta.space/protest",
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('safe.deal.protest.button')) + " ")]) : _c('simple-button', {
    on: {
      "click": _vm.handleResolve
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('safe.deal.closed.dispute.button')) + " ")])], 1), _c('div', {
    class: _vm.$style.action
  }, [_c('simple-button', {
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('refund');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('safe.deal.refund.button')) + " ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }